import React from "react";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

const Pagination = ({ length, currentPage, handlePagination }) => {
  const maxVisiblePages = 5; // Number of pages to show before "..."

  const getPageNumbers = () => {
    let pages = [];
    const half = Math.floor(maxVisiblePages / 2);

    if (length <= maxVisiblePages) {
      pages = Array.from({ length: length }, (_, i) => i + 1);
    } else {
      if (currentPage === 1 || currentPage === 2) {
        pages = [1, 2, 3, "...", length];
      } else if (currentPage === length) {
        pages = [1, "...", length - 2, length - 1, length];
      } else if (currentPage === length - 1) {
        pages = [1, "...", length - 2, length - 1, length];
      } else {
        pages = [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          length,
        ];
      }
    }

    return pages;
  };
  return (
    <div className="pagination">
      {/* Left Arrow */}
      <button
        className={`px-3 py-1 border rounded ${
          currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
        }`}
        onClick={() => currentPage > 1 && handlePagination(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <FaChevronLeft />
      </button>
      {/* Page Numbers */}
      {getPageNumbers().map((page, index) => (
        <>
          <button
            key={index}
            className={`px-3 py-1 border rounded ${
              page === currentPage ? "bg-blue-500 text-white" : ""
            }`}
            onClick={() => typeof page === "number" && handlePagination(page)}
            disabled={page === "..."}
          >
            {page}
          </button>

          {/* Right Arrow */}
        </>
      ))}
      <button
        className={`px-3 py-1 border rounded ${
          currentPage === length ? "opacity-50 cursor-not-allowed" : ""
        }`}
        onClick={() =>
          currentPage < length && handlePagination(currentPage + 1)
        }
        disabled={currentPage === length}
      >
        <FaChevronRight />
      </button>
      {/* {paginationNumber.map((data) => (
        <button
          key={data}
          onClick={() => handlePagination(data)}
          className={currentPage === data ? "active" : ""}
        >
          {data}
        </button>
      ))} */}
    </div>
  );
};
export default Pagination;
